/* eslint-disable no-extend-native */
import { SpecialGradeLevel } from '@suntex.fim/enums'

import { getLocalization } from './getLocale'

declare global {
  interface Number {
    noun(singular: string, plural: string): string
    toGradeString(): string
  }
}

export function extendNumberType() {
  Number.prototype.noun = function (singular: string, plural: string) {
    return this === 1 ? singular : plural
  }

  Number.prototype.toGradeString = function () {
    switch (Number(this)) {
      case SpecialGradeLevel.Kindergarten:
        return 'PK / Kindergarten'
      case SpecialGradeLevel.Unassigned:
        return 'Unassigned'
      case SpecialGradeLevel.Other:
        return 'Other'
      default:
        return getLocalization().text(`Grade ${this.toString()}`)
    }
  }
}
